import axios from "axios";

export const state = {
    students: [],
};

export const getters = {
    students: state => state.students,
};

export const mutations = {
    setStudents(state, newValue) {
        state.students = newValue
    },
};

export const actions = {
    fetchStudents({ commit }) {
        axios.get('/students').then(res => {
            commit('setStudents', res.data.students);
        })
    },
    filterStudents({commit}, {schoolterm,year,schoolclass,schoolstream}) { 
        let formData = new FormData();
        formData.append("schoolterm", schoolterm);
        formData.append("year", year);
        formData.append("schoolclass", schoolclass);
        formData.append("schoolstream", schoolstream);
        let url = "/filterstudents";
        axios.post(url, formData).then((response) => {
            commit('setStudents', response.data.students)
        })
    },
};
